
/* styles */
require("!!vue-loader/node_modules/vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-3f251002&scoped=true!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./affix.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./affix.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-3f251002!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./affix.vue"),
  /* scopeId */
  "data-v-3f251002",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/affix/src/affix.vue
// module id = 516
// module chunks = 0